{
    "websiteName": "okmagazine.ro",
    "websitePushID": "web.okmagazine-ro.adh.reperio.news",
    "allowedDomains": [
        "https://okmagazine.ro",
        "https://www.okmagazine.ro"
    ],
    "urlFormatString": "https://okmagazine.ro/%@",
    "authenticationToken": "19f8d7a6e9fb8a7f6d9330dabe",
    "webServiceURL": "https://okmagazine.ro/apple_webpush"
}
